import React, { Component } from 'react';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { withStyles } from '@material-ui/core/styles';
import { orange } from '@material-ui/core/colors';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import Switch from '@material-ui/core/Switch';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import '/css/popup_data_editor.css';

const toolBar = {
    options: ['inline'],
    inline: {
        options: ['bold', 'italic', 'underline'],
    },

    // fix this friday
    // link: {
    //     visible: true,
    //     options: ['link', 'unlink'],
    //     // className: "popUp",
    //     linkCallback: (old) => {
    //         console.log("GUOEHNGIVJN");
    //         return {title:"foo", target:"https://test.com", targetOption:"_self"};
    //     },
    // },
}

class StTextArea extends Component {
    constructor(props) {
        super();
        const html = props.html || "";
        this.htmlCallBack = props.callback || console.log;
        const contentBlock = htmlToDraft(html);
        if (contentBlock) {
            const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
            const editorState = EditorState.createWithContent(contentState);
            this.state = {
                editorState,
            };
        }
    }

    onEditorStateChange = (editorState) => {
        this.setState({
            editorState,
        });
        this.htmlCallBack(draftToHtml(convertToRaw(editorState.getCurrentContent())));
    };

    onTextAreaChange = (newText) => {

        this.htmlCallBack(newText);
    }

    EditSwapper = (props) => {

        const OrangeSwitch = withStyles({
            switchBase: {
                color: orange[300],
                '&$checked': {
                    color: orange[500],
                },
                '&$checked + $track': {
                    backgroundColor: orange[500],
                },
            },
            checked: {},
            track: {},
        })(Switch);

        const [switchState, setSwitchState] = React.useState({
            checked: false,
        });

        const [htmlState, setHtmlState] = React.useState("");

        const handleChange = (event) => {
            if (!event.target.checked) {
                const contentBlock = htmlToDraft(htmlState);
                if (contentBlock) {
                    const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
                    const editorState = EditorState.createWithContent(contentState);
                    this.setState({
                        editorState,
                    });
                }
            } else {
                setHtmlState(draftToHtml(convertToRaw(props.state.getCurrentContent())))
            }

            setSwitchState({ switchState, [event.target.name]: event.target.checked });
        };


        if (!switchState.checked) {
            return (
                <div>
                    Edit as HTML <OrangeSwitch
                        checked={switchState.checked}
                        onChange={handleChange}
                        name="checked"
                        inputProps={{ 'aria-label': 'primary checkbox', "color": "#33dd33" }}
                    />
                    <Editor
                        editorStyle={this.props.style}
                        toolbar={toolBar}
                        editorState={props.state}
                        editorClassName="prettyInput fw3"
                        onChange={(raw) => { this.htmlCallBack(draftToHtml(raw)) }}
                        onEditorStateChange={this.onEditorStateChange}
                    />
                </div>
            );
        }
        return (
            <div>
                Edit as HTML <OrangeSwitch
                    checked={switchState.checked}
                    onChange={handleChange}
                    name="checked"
                    inputProps={{ 'aria-label': 'primary checkbox', "color": "#33dd33" }}
                />
                <br />
                <textarea
                    className="popupTextArea"
                    value={htmlState}
                    onChange={(newData) => {
                        console.log(newData.target.value);
                        setHtmlState(newData.target.value);
                        this.htmlCallBack(newData.target.value);
                    }}
                />
            </div>
        )
    }

    render() {
        const { editorState } = this.state;
        return (
            <div>
                <this.EditSwapper state={editorState} />
            </div>
        );
    }
}

export default StTextArea;